module.exports = __webpack_public_path__ + "img/rhomb_list_marker.f79deeaf.svg";